<template>
    <div class="slider">
        <transition-group name="fade" :duration="fadeTime">
            <div
                class="slider-item"
                v-for="(image, imageIndex) of images"
                v-if="showImage(image)"
                :style="{ backgroundImage: 'url(\'' + image + '\')', transition: fadeTime + 'ms linear opacity'}"
                :key="blockId + '_' + imageIndex + '_' + image"
            />
        </transition-group>

    </div>
</template>

<script>
    export default {
        name: "PhotoSlider",

        props: {
            blockId:{

            },
            fadeTime: {
                type: Number,
                default: 3000
            },
            images: {
                type: Array,
                required: true,
            },
            currentImageIndex: {
                type: Number | null,
                required: true
            }
        },

        methods: {
            showImage(image) {
                return this.images.indexOf(image, this.currentImageIndex) === this.currentImageIndex;
            }
        }
    }
</script>

<style scoped lang="scss">

    .fade-enter, .fade-leave-to {
        opacity: 0;
    }

    .slider {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        .slider-item {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;

            background-size: contain;
            background-position: center center;
            background-repeat: no-repeat;
        }
    }
</style>
